export enum InteractionStatus {
  SENDING = 'sending',
  SUCCESS = 'success',
  FAIL = 'fail',
  NONE = 'none',
}
